<template>
  <div class="info-container">
    <div class="details-panel">
      <h6>Import Details</h6>
      <div class="row" v-for="(entry, index) in details" :key="index">
        <b>{{entry.title}}</b>
        <span>:</span>
        <p v-if="entry.title === 'File Name'">
          <u @click="downloadFile('input')">{{entry.value}}</u>
          <u v-if="getterSectionDetails.status !== 'VALIDATING'" class="l-border"
            @click="downloadFile('output')">
            Output File
          </u>
        </p>
        <div v-else-if="typeof entry.value === 'object'">
          <p v-for="(data, dataIndex) in entry.value" :key="dataIndex">
            <span class="key">{{data.key}}</span>-
            <span class="value">{{data.value}}</span>
          </p>
        </div>
        <p v-else>
          {{entry.value}}
          <i v-if="entry.title === 'Import Status' && !['PROCESSED', 'NOT_PROCESSED'].includes(entry.value)"
            class="fa fa-sync-alt" @click="refreshImportStatus" />
        </p>
      </div>

      <p class="centered" v-if="details.length === 0">Loading...</p>
    </div>

    <button v-if="isDesktop()" class="primary-btn" @click="goBack">
      <i class="fa fa-angle-left" />
      Back
    </button>
  </div>
</template>

<script>
import ApiServices from '@/services/api/imports'
import { mapGetters, mapMutations } from 'vuex'
import { goBack } from '@/utils/helpers'

export default {
  name: 'ImportDetails',
  data () {
    return {
      details: []
    }
  },
  created () {
    this.SET_SECTION_DETAILS(null)
  },
  beforeDestroy () {
    this.SET_SECTION_DETAILS(null)
  },
  computed: {
    ...mapGetters(['getterSectionDetails'])
  },
  watch: {
    getterSectionDetails (newVal) {
      this.populateData(newVal)
    }
  },
  methods: {
    goBack,
    ...mapMutations(['SET_SECTION_DETAILS', 'SET_IMPORT_STATUS']),
    populateData (data) {
      this.details = []
      if (!data) {
        return
      }

      const addParam = (title, value) => {
        this.details.push({
          title, value
        })
      }
      const getTxnStatus = (status) => {
        return [
          {
            key: 'Completed',
            value: status.completed
          },
          {
            key: 'Failed',
            value: status.failed
          },
          {
            key: 'Pending',
            value: status.pending
          }
        ]
      }

      addParam('ID', data.id)
      addParam('Purpose', data.purpose)
      addParam('Transaction Type', data.txn_type)
      addParam('File Name', data.file_name)
      addParam('Processed', data.initiated_txns + ' / ' + data.total_entries)
      addParam('Unprocessed', data.invalid_entries + ' / ' + data.total_entries)
      addParam('Transaction Status', getTxnStatus(data.txn_stats))
      addParam('Import Status', data.status)
    },
    downloadFile (type) {
      ApiServices.download(this.getterSectionDetails.id, {file_type: type}).then(response => {
        if (response.success) {
          location.href = response.data.download_url
        } else {
          this.errorToastMsg(response.message)
        }
      })
    },
    refreshImportStatus () {
      this.SET_SECTION_DETAILS(null)
      this.SET_IMPORT_STATUS()
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/detailsPanel.scss';

  .info-container {
    .details-panel {
      p {
        .key {
          min-width: 85px;
          display: inline-block;
          font-weight: 400 !important;
        }
        .value {
          margin-left: 10px;
          font-weight: 500 !important;
        }
        .l-border {
          border-left: 1px solid $grey-outline;
          padding-left: 10px;
          margin-left: 10px;
        }
      }

      .fa-sync-alt {
        margin-left: 5px;
        cursor: pointer;
        color: $primary;
      }
    }
  }

  .mobile, .tablet {
    .details-panel {
      b {
        min-width: 130px !important;
      }
    }
  }
</style>
